import React, { useCallback } from "react";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BTable from 'react-bootstrap/Table';
import { HeaderList } from "../../../components/HeaderList";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { BranchService } from "../../../services/branch.service";
import { BranchModel } from "../../../models/branch.model";
import { EquipmentModel } from "../../../models/equipment.model";
import { EquipmentService } from "../../../services/equipment.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import { HeadDateModel } from "../../../models/headDate.model";
import { EventExportService } from "../../../services/eventExport.service";
import { ForeCastService } from "../../../services/forecast.service";
import storageService from "../../../services/storage.service";
import UtilService from "../../../services/util.service";
import { useTable, usePagination, useSortBy } from 'react-table';
import { faSortAlphaUp, faSortAlphaDown, faSort } from "@fortawesome/free-solid-svg-icons";
import HelperService from "../../../services/helper.service";
import { ButtonClean, ButtonSearch, ButtonExport } from "../../../components/buttons";
import Pagination, { IPag, IPagination } from "../../../components/Pagination";
import moment from "moment";


function Table({columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];
  
  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style = {
      border: 'none',
      background: cellInfo.background,
      color: 'white',
      fontWeight: 600,
      textAlign: 'center'
    };
    return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style = {
      width: '100%',
      height: '100%',
      padding: 2
    };

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <>
      <BTable bordered hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={formatCellStyleHeader(column)}
                >
                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <div style={{ display: "table-caption" }}>
                      {column.render('Header')}
                    </div>
                    {column.canSort
                      ? column.isSorted
                        ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                        : <FontAwesomeIcon icon={faSort} />
                      : null
                    }
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            const isUpdated = row.original.isUpdated;
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {

                  if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                    return <td
                      colSpan={7}
                      {...cell.getCellProps()}
                      style={{
                        background: "#fff",
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        color: '#555',
                        padding: 0,
                        opacity: isUpdated ? 1 : 0.65
                      }}
                    >
                      <div style={formatCellStyle(cell)}>
                        {msgEmpty}
                      </div>
                    </td>
                  }

                  if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                    return <></>;
                  }
                  return (
                    <td
                      {...cell.getCellProps()}
                      style={{
                        background: "#fff",
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        color: '#555',
                        padding: 0,
                        opacity: isUpdated ? 1 : 0.65
                      }}
                    >
                      <div style={formatCellStyle(cell)}>
                        {cell.render('Cell')}
                      </div>
                    </td>
                  )
                }
                )}
              </tr>
            )
          })}
        </tbody>
      </BTable>
    </>
  );
}

const InconsistentList = () => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();
  const [headDate, setHeadDate] = useState<HeadDateModel>();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_inconsistent_forecast',
    filters: {
      branch_id: [],
      code_equipment: []
    },
    parameters: {}
  });

  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const [branches, setBranches] = useState<BranchModel[]>();
  const [equipments, setEquipments] = useState<EquipmentModel[]>();
  const [codeEquipment, setCodeEquipment] = useState<string>();
  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_inconsistent_forecast',
    filters: {
      branch_id: [],
      code_equipment: []
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });

  const [pagination, setPagination] = useState<IPag>();

  const updatePage = useCallback(async (page: number) => {
    getList({
      page_number:page+1
    })
    setPagination({
        ...pagination,
        actualPage: page,
    })
  }, [pagination])  

  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Equipamento",
        background: '#4b4b50',
        columns: [
          {
            Header: props => (<span>{t("REPORT.CODE_EQUIPMENT")}</span>),
            accessor: "code_equipment",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (props.value)
          },
          {
            Header: props => (<span>{t("FILTER.BRANCH")}</span>),
            accessor: "branch_nickname",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (props.value)
          },
          {
            Header: props => (<span>{t("DEPOSIT.READ_DATE")}</span>),
            accessor: "date",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (formatDateTime(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_DATE")}</span>),
            accessor: "balance_date",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (formatDateTime(props.value))
          }
        ]
      },
      {
        Header: "Saldo",
        background: '#008000',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE")}</span>),
            accessor: "balance",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE_CALCULATION")}</span>),
            accessor: "forecast_balance",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE_DIFERENCE")}</span>),
            accessor: "balance_diff",
            disableSortBy: true,
            background: '#2E8B57',
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_PERCENT_DIFERENCE")}</span>),
            background: '#2E8B57',
            accessor: "balance_perc_diff",
            disableSortBy: true,
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_balance_perc_diff, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }
    ],
    [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]
  );

  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };

  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  const initialize = async () => {
    BranchService.getAllList().then((response: any) => {
      if(response.success){
        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
        const sort = Array.isArray(branchList?.[0]?.data)
          ? branchList[0].data.sort((a, b) => (a?.fullName || "").localeCompare(b?.fullName || ""))
          : [];
        setBranches(sort);
      }else{
        setBranches([]);
      }
    });

    EquipmentService.getAllList().then((response: any) => {
      if (response.success) {
        let equipmentList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'equipment' });
        const sort = Array.isArray(equipmentList?.[0]?.data)
        ? equipmentList[0].data.sort((a, b) => (a?.codeEquipment || "").localeCompare(b?.codeEquipment || ""))
        : [];
        setEquipments(sort);
      } else {
        setEquipments([]);
      }
    });

    await getList({
      page_number:1
    })
  };

  const exportFile = async () => { 
    getListExport(null);
  };

  const getListExport = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    requestParams.parameters = {
      ...requestParams.parameters
    }

    EventExportService.ExportInconsistentForecast(requestParams).finally(() =>
      setLoading(false)
    );
  };


  const getList = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    requestParams.parameters = {
      ...requestParams.parameters
    }

    const response: any = await ForeCastService.getInconsistentList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'report_inconsistent_forecast' }));
      setDatasetDashboardAnalytical(d);
      let pagesArray: number[] = [];
      for (let i = 0; i < d.pagination.total_pages!; i++) {
        pagesArray.push(i)
      }
      var pagination = {
        actualPage: d.pagination.page_number-1,
        totalPages: d.pagination.total_pages,
        limit: d.pagination.records_pages,
        pagesArray: pagesArray,
        page_number: d.pagination.page_number,
        total_pages: d.pagination.total_pages,
        records_pages: d.pagination.records_pages,
        total_records: d.pagination.total_records
      }
      setPagination(pagination)
    }
    else {
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
    }

    setLoading(false);
  };


  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();
    await getList({
      page_number:1
    });
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => {
    setDataset({ ...dataset, filters: { branch_id: [], code_equipment: [] } })
    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { branch_id: [], code_equipment: [] } })
    setCodeEquipment('');
    setFlagClear(true);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <HeaderList title={t(`INCONSISTENT.FORECAST_ANALYSIS`)} />
        <p style={{color: '#3749D6', fontSize: '18px'}}><span style={{textDecoration: 'underline'}}>{t('REPORT.REPORT_PERIOD')}</span>: <b>{moment().subtract(7, 'day').format("DD/MM/YYYY")} {t('REPORT.TO')} {moment().subtract(1, 'day').format("DD/MM/YYYY")}</b></p>
      </div>
      <Form>
        <Form.Label className="mb-1">{t("FILTERS")}</Form.Label>
        <Row className="align-items-center">
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='code_equipment'
                  id='code_equipment'
                  type='text'
                  placeholder={t(`EQUIPMENT.CODE_EQUIPMENT`)}
                  className='form-control'
                  value={codeEquipment}
                  onChange={(e) => {
                    setCodeEquipment(e.target.value.trim())
                    if (e.target.value.trim() !== '') {
                      setDataset({ ...dataset, filters: { ...dataset.filters, code_equipment: [e.target.value.trim()] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, code_equipment: [e.target.value.trim()] } })
                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, code_equipment: [] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, code_equipment: [] } })
                    }
                  }} />
                <label>{t("FILTER.EQUIPMENT")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.branch_id.length > 0 ? dataset?.filters?.branch_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, branch_id: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, branch_id: [Number(e.target.value)] } })
                  }}
                >
                  <option>{t("FILTER.SELECT")}</option>
                  {_.map(branches, (item: BranchModel) => {
                    return <option key={item.id} value={item.id}>{item.fullName}</option>
                  })}
                </Form.Control>
                <label>{t("FILTER.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
        </Row>  
        <Row className='mt-3'>
          <Col xs="auto">
            <ButtonSearch onClick={(e) => handleSearch(e)} isLoading={isLoading} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => handleClean()} isLoading={isLoading}/>
          </Col>

          <Col xs="auto">
            <ButtonExport onClick={() => exportFile()} isLoading={isLoading}/>
          </Col>
        </Row>
      </Form>
      <br/>
      <Row className="align-items-center pb-3">
        <Col sm={12}>          
          <Table
            data={data}
            columns={columns}
            update={null}
            total_records={21}
            msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} />
        </Col>
      </Row>
      <Pagination pagination={pagination} updatePage={updatePage} />
    </>
  );
};

export default InconsistentList;
